import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import resourceFactory from "common/admin/resourceFactory";
import { isEqual } from "lodash";
import Snackbar from "@mui/material/Snackbar";
import { transformApiError } from "common/api";

class Resource extends Component {
  state = {
    data: [],
    page: 1,
    loaded: false,
    snackbarOpen: false,
    snackbarMessage: "",
  };

  actions = resourceFactory(this.props.name);

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.name === this.props.name &&
      prevProps.resourceId === this.props.resourceId &&
      isEqual(prevProps.queryParams, this.props.queryParams)
    ) {
      return null;
    }
    this.actions = resourceFactory(this.props.name);
    this.getData();
  }

  getData() {
    const { resourceId } = this.props;

    if (resourceId) {
      return this.getOne(resourceId);
    }

    this.getAll();
  }

  async getOne(id) {
    try {
      const data = await this.actions.getOne(id);
      this.setState({ data, loaded: true });
    } catch (e) {
      this.setState({ error: true, loaded: true });
    }
  }

  async getAll() {
    const isFloorPropName = this.props.name === "floors";
    const limitObject = isFloorPropName
      ? {}
      : { limit: this.props.limit, page: this.state.page };
    const params = {
      ...this.props.queryParams,
      ...limitObject,
    };
    try {
      const data = await this.actions.getAll(params);
      this.setState({ data, loaded: true });
    } catch (e) {
      this.setState({ error: true, loaded: true });
    }
  }

  changePage(page) {
    this.setState({ page }, this.getAll);
  }

  prevPage = () => {
    let page = this.state.page;
    if (this.state.page > 1) {
      page = page - 1;
    }
    this.changePage(page);
  };

  nextPage = () => {
    const page = this.state.page + 1;
    this.changePage(page);
  };

  removeOne = async (id, params = {}) => {
    try {
      await this.actions.removeOne(id);
      this.getAll();
    } catch (e) {
      const error = transformApiError(e);
      if (error.empty()) {
        this.setSnackbar("An unknown error occurred.");
      } else {
        const err = error.array(0);
        this.setSnackbar(`An error occurred: ${err.msg}`);
      }
    }
  };

  reload = () => {
    this.getAll();
  };

  setSnackbar = (msg) => {
    this.setState({ snackbarOpen: true, snackbarMessage: msg });
  };

  clearSnackbar = () => {
    this.setState({ snackbarOpen: false, snackbarMessage: "" });
  };

  render() {
    if (this.state.error) {
      return (
        <p style={{ padding: "1em" }}>Unable to load {this.props.name}.</p>
      );
    }

    if (!this.state.loaded) {
      return <p style={{ padding: "1em" }}>Loading...</p>;
    }

    return (
      <Fragment>
        {this.props.render(this.state.data, {
          reload: this.reload,
          removeOne: this.removeOne,
          nextPage: this.nextPage,
          prevPage: this.prevPage,
          page: this.state.page,
        })}
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={this.state.snackbarOpen}
          autoHideDuration={5000}
          onClose={this.clearSnackbar}
          message={<span>{this.state.snackbarMessage}</span>}
        />
      </Fragment>
    );
  }
}

Resource.defaultProps = {
  limit: 10,
};

Resource.propTypes = {
  name: PropTypes.string.isRequired,
  resourceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  limit: PropTypes.number,
  queryParams: PropTypes.object,
};

export default Resource;
